export interface ModuleItemSubType {
  attributes?: string[];
  icon?: string;
  label?: string;
  type?: string;
  itemType?: string;
}

export enum ModuleItemAvailableSubType {
  STATEMENT = 'statement',
  VIDEO_AUDIO = 'video_audio',
  GRAPH = 'graph',
  INPUT = 'input',
  SLIDER = 'slider',
  DROPDOWN = 'dropdown',
  SINGLE_CHOICE = 'singlechoice',
  MULTIPLE_CHOICE = 'multiplechoice',
  SINGLE_LINE = 'singleline',
  MULTI_LINE = 'multiline',
  YES_NO = 'yesno',
  YES_NO_OTHER = 'yesnoother',
  LIKERT = 'likert',
  IMAGE = 'image',
  QUADRANT = 'quadrant',
  ORBITS = 'orbits',
  NETWORK = 'network',
  AUDIO_RECORDING = 'audiorecording',
  IVY = 'ivy',
}

export const ModuleItemForbiddenSubTypesCC = [
  ModuleItemAvailableSubType.IMAGE,
  ModuleItemAvailableSubType.GRAPH,
  ModuleItemAvailableSubType.QUADRANT,
  ModuleItemAvailableSubType.ORBITS,
  ModuleItemAvailableSubType.NETWORK,
  ModuleItemAvailableSubType.AUDIO_RECORDING,
  ModuleItemAvailableSubType.IVY,
];

export const ModuleItemForbiddenSubTypesTIIM = [ModuleItemAvailableSubType.YES_NO_OTHER];

export const ModuleItemForbiddenSubTypesSubscription = [
  ModuleItemAvailableSubType.IMAGE,
  ModuleItemAvailableSubType.ORBITS,
  ModuleItemAvailableSubType.NETWORK,
  ModuleItemAvailableSubType.AUDIO_RECORDING,
  ModuleItemAvailableSubType.IVY,
];
